// ══════════════════════════════════════════════════════════════════════════════
// PAGE ASSISTANT IA - COCKPIT PARTICULIER
// Route: /cockpit-particulier/assistant
// Interface Claude-style avec Artifacts (même que les Pros)
// ══════════════════════════════════════════════════════════════════════════════

import React from 'react';
import { useNavigate } from 'react-router-dom';
import AssistantFullPage from '../assistant/AssistantFullPage';

export default function AssistantParticulierPage() {
  const navigate = useNavigate();
  
  // On réutilise la même interface AssistantFullPage
  // avec un contexte "particulier" pour adapter les suggestions
  return (
    <AssistantFullPage 
      userContext="particulier"
      onClose={() => navigate('/cockpit-particulier')}
    />
  );
}
